module.exports = __webpack_public_path__ + "igdcbm-bbcc959e.webp";